
import React from 'react';
import Layout from '../common/Layout';
import { Skeleton } from '../ui/skeleton';

const LoadingState: React.FC = () => {
  return (
    <Layout title="Detalle de Receta" showBackButton={true}>
      <div className="space-y-4">
        <Skeleton className="h-40 w-full" />
        <Skeleton className="h-8 w-2/3" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-20 w-full" />
      </div>
    </Layout>
  );
};

export default LoadingState;
